<template>
	<div class="Filter">

		<template v-if='template == "participants"'>
			<participants
				:data='data'
				@FILTER_CHANGE='onChange'
				@FILTER_CHANGE_PAYLOAD='onChangePayload'
			/>
		</template>

		<template v-else>
			Unknown filter template: <b>{{template}}</b>
		</template>

	</div>
</template>

<script>
module.exports = {
	props: [
		'template',
		'data'
	],
	components: {
		participants: require('./filters/participants.vue')
	},

	methods: {
		onChange(payload) {
			// console.log(payload);
			this.$emit('FILTER_CHANGE', payload);
		},

		onChangePayload(payload) {
			this.$emit('FILTER_CHANGE_PAYLOAD', payload);
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Filters.vue?4c20a43d